var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('password-dialog',{ref:"secureDataRequest"}),_c(_vm.mainComponent,{tag:"component",attrs:{"error":_vm.liveDirectorError,"split-error":_vm.splitError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }